import { isNil } from 'lodash-es';
import { formatMaestroDate, type MaestroDate } from '../../utils/date';
import type { FieldConfig } from './ProgrammingSubPlanFieldConfig';
import { UnknownValue, UnknownValueLabel } from './SpecificData';

export const getFieldValueLabel = (
  field: FieldConfig,
  rawValue: unknown
): string | null => {
  if (isNil(rawValue)) {
    return null;
  }

  const sortedOptions = [...field.options].sort((a, b) => a.order - b.order);

  switch (field.inputType) {
    case 'checkbox':
      return rawValue ? field.label : null;
    case 'select':
    case 'radio':
      return (
        sortedOptions.find((o) => o.value === rawValue)?.label ||
        String(rawValue)
      );
    case 'selectWithUnknown':
      if (rawValue === UnknownValue) return UnknownValueLabel;
      return (
        sortedOptions.find((o) => o.value === rawValue)?.label ||
        String(rawValue)
      );
    case 'multiselect': {
      const values = rawValue as string[];
      if (values.length === 0) return null;
      return values
        .map(
          (value) =>
            sortedOptions.find((o) => o.value === value)?.label || value
        )
        .join(', ');
    }
    case 'decimal':
      return String(rawValue).replace('.', ',');
    case 'date':
      return formatMaestroDate(rawValue as MaestroDate);
    case 'text':
    case 'number':
    case 'textarea':
      return String(rawValue);
    default:
      return String(rawValue);
  }
};
